import { useDebounce } from "@/shared/client";
import { Box } from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import { ControlArrows, ControlDots } from "./components";
import { useSlide } from "./hooks";
import { type SectionVerticalSlideProps } from "./types";

export const SectionVerticalSlide = ({ isNotFirstBtn, isNavigateRadio, children }: SectionVerticalSlideProps) => {
    const [childHeight, setChildHeight] = useState(0);
    const [slideHeight, setSlideHeight] = useState(0);
    const childrenArray = React.Children.toArray(children);
    const childrenLength = childrenArray.length;
    const {
        currentIdx,
        prevSlide,
        nextSlide,
        goSlide,
        handleWheel,
        handleTouchEnd,
        handleTouchMove,
        handleTouchStart,
    } = useSlide(childrenLength);
    const { debouncedFunction } = useDebounce();

    const childRef = useRef<HTMLDivElement>(null);
    const resizeObserver = new ResizeObserver(() => {
        updateHeight();
    });
    const updateHeight = () => {
        if (childRef.current && childRef.current.children.length > 0) {
            const nextChild = childRef.current.children[0] as HTMLDivElement;
            setChildHeight(nextChild.offsetHeight);
        }
    };
    useEffect(() => {
        if (childRef.current) {
            resizeObserver.observe(childRef.current);
        }
        window.addEventListener("resize", updateHeight);
        return () => {
            resizeObserver.disconnect();
            window.removeEventListener("resize", updateHeight);
        };
    }, [children, resizeObserver]);

    useEffect(() => {
        updateHeight();
    }, []);

    const getTotalHeightBeforeCurrentSlide = () => {
        let slideHeight = 0;

        if (childRef.current) {
            for (let i = 1; i < currentIdx; i += 1) {
                slideHeight = (childRef.current.children[i] as HTMLDivElement).offsetHeight + slideHeight;
            }
        }
        return slideHeight;
    };
    useEffect(() => {
        setSlideHeight(getTotalHeightBeforeCurrentSlide());
    }, [currentIdx]);
    return (
        <Box
            position="relative"
            overflow="hidden"
            onWheel={debouncedFunction(handleWheel, 500)}
            onTouchStart={handleTouchStart}
            onTouchEnd={debouncedFunction(handleTouchEnd, 500)}
            onTouchMove={handleTouchMove}
        >
            <Box
                ref={childRef}
                width="100%"
                height={`${childHeight}px`}
                transform={`translateY(-${slideHeight}px)`}
                transition="0.5s ease-in-out"
            >
                {childrenArray.map((child) => child)}
            </Box>
            <ControlDots
                childLength={childrenLength}
                isNavigateRadio={isNavigateRadio}
                goSlide={goSlide}
                currentIdx={currentIdx}
            />
            <ControlArrows
                childLength={childrenLength}
                currentIdx={currentIdx}
                nextSlide={nextSlide}
                prevSlide={prevSlide}
                isNotFirstBtn={isNotFirstBtn}
            />
        </Box>
    );
};
